import { Children, isValidElement, useCallback, useMemo, useState } from "react";
import { isValidSectionItem } from "../guards.js";
function useFilterChildren(props) {
  const { children, expanded, pageSize, maxPinned = Number.POSITIVE_INFINITY } = props;
  const [loadedPages, setLoadedPages] = useState(1);
  const { top, pinned, content, hasMoreContent } = useMemo(() => {
    const top2 = [];
    const pinned2 = [];
    const content2 = [];
    let warned = false;
    for (const child of Children.toArray(children)) {
      if (!isValidElement(child)) continue;
      const { item, pin } = isValidSectionItem(child) ? { pin: child.props.pinned, item: child.props.children } : { item: child, pin: void 0 };
      const hitPinLimit = top2.length + pinned2.length >= maxPinned;
      if (!warned && !!pin && hitPinLimit) {
        warned = true;
        console.warn("Number of pinned items exceeds maxPinned.");
      }
      if (pin === "top" && !hitPinLimit) {
        top2.push(item);
      } else if (pin === "pinned" && !hitPinLimit && !expanded) {
        pinned2.push(item);
      } else {
        content2.push(item);
      }
    }
    const requestedItems = pageSize ? loadedPages * pageSize : void 0;
    const pagedContent = content2.slice(0, requestedItems);
    const hasMoreContent2 = content2.length > (requestedItems ?? Number.POSITIVE_INFINITY);
    return {
      top: top2,
      pinned: pinned2,
      hasMoreContent: hasMoreContent2,
      content: pagedContent
    };
  }, [children, expanded, loadedPages, maxPinned, pageSize]);
  const loadMore = useCallback(() => {
    if (!hasMoreContent) return;
    setLoadedPages((pages) => pages + 1);
  }, [hasMoreContent]);
  return {
    top,
    pinned,
    content,
    loadMore,
    hasMoreContent
  };
}
export {
  useFilterChildren
};
//# sourceMappingURL=useFilterChildren.js.map
